import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { MomentRecipientsClassify } from "../../../../../../hooks/use-moment-recipients-classify";
import { PreviewWithSidebarAutocomplete } from "./preview-with-sidebar-autocomplete";

export const PreviewWithSidebarRecipients: FC<{
  data: Extract<MomentRecipientsClassify, { type: "recipients" }>["data"];
}> = ({ data }) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="body2">Select a recipient to preview merge tags</Typography>
      <Typography variant="body2" color="textSecondary">
        Message to {data.segment_name}
      </Typography>
      <PreviewWithSidebarAutocomplete info={{ type: "recipients", data }} />
    </Stack>
  );
};
